var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book-grid"},_vm._l((_vm.books),function(book){return _c('BookThumbnail',{key:book.id,attrs:{"book":book}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }